import React from 'react';
import './style.css'

const Footer=()=>{
    return(
        <section className='footer'>
           <div className="footer-container">
               <div className="footer-content">
                   Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum consequuntur natus fugiat doloremque pariatur officiis maiores nesciunt? Quas vitae, nesciunt ad, rem consectetur beatae veniam adipisci aperiam exercitationem blanditiis assumenda.
               </div>
               <div className="footer-copyright">
                   <p>&copy;Copyright GetUp!Edutainment 2020</p>
               </div>
           </div>
        </section>
    )
}

export default Footer